<!-- 需求跟踪 -->
<template>
  <div>
    <!-- 搜索 -->
    <!-- <div class="search-box">
      <el-form :model="listQuery" class="search-form" size="small">
        <el-form-item label="需求计划名称：">
          <el-input
            v-model.trim="listQuery.purchaseDemandName"
            placeholder="请输入需求计划名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="需求计划编号：">
          <el-input
            v-model.trim="listQuery.purchaseDemandCode"
            placeholder="请输入需求计划编号"
          ></el-input>
        </el-form-item>
        <el-form-item label="创建日期：" label-width="112px" prop="salesScopeId">
          <el-date-picker
            v-model="listQuery.submitTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="状态：" label-width="100px" prop="salesScopeId">
          <el-select
            v-model="listQuery.purchaseDemandStatus"
            filterable
            clearable
            placeholder="请选状态"
          >
            <el-option
              v-for="(val, key) in purchaseDemandStatusObj"
              :key="key"
              :label="val"
              :value="key"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="search-btn">
        <div class="btn reset-btn" size="small" @click="handleReset">重置</div>
        <div class="btn submit-btn" size="small" @click="handleQuery">查询</div>
      </div>
    </div> -->
    <!-- 搜索 -->
    <div class="container">
      <e-search
        :data="listQuery"
        :field-list="fieldList"
        :list-type-info="listTypeInfo"
        @handleFilter="handleQuery"
        @handleReset="handleReset"
      ></e-search>
    </div>

    <!-- 操作按钮 -->
    <div class="container">
      <div class="handle-wrapper">
        <eui-btn type="secondary" @click="exportDemandTrackLogSummary"
          >导出概要</eui-btn
        >
        <eui-btn type="secondary" @click="exportDemandTrackLogDetail"
          >导出明细</eui-btn
        >
      </div>
      <eTableList
        :table-data="tableData"
        :table-label="tableLabel"
        :index-show="true"
      >
        <template #purchaseDemandTrackStatusDesc="{ scope }">
          <eui-btn type="link" font-size="12px" @click="openPlan(scope.row)">
            {{ scope.row.purchaseDemandTrackStatusDesc }}
          </eui-btn>
        </template>
        <template #purchaseDemandCode="{ scope }">
          <eui-btn
            type="link"
            font-size="12px"
            @click="goDetail(scope.row.purchaseDemandId)"
          >
            {{ scope.row.purchaseDemandCode }}
          </eui-btn>
        </template>
      </eTableList>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :total="total"
          :page-size.sync="listQuery.pageSize"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div>

    <!-- <div class="search-btn export-wrapper">
      <div class="btn submit-btn margin-r20" size="small" @click="exportDemandTrackLogSummary">
        导出概要
      </div>
      <div class="btn submit-btn" size="small" @click="exportDemandTrackLogDetail">导出明细</div>
    </div>

    <div class="table-box">
      <el-table
        v-loading="tableLoading"
        ref="tableData"
        :data="tableData"
        border
        :header-cell-style="{ background: '#F5F5F5' }"
      >
        <el-table-column label="序号" min-width="60">
          <template #default="scope">
            {{ scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="orgShortName"
          label="需求部门"
          min-width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="createMemberName"
          label="需求申请人"
          min-width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="categoryName"
          label="物料分类"
          min-width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="categoryCustomCode"
          label="物料编码"
          min-width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="categoryDesc"
          label="物料描述"
          min-width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="quantity"
          label="采购数量"
          min-width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="readyQuantity"
          label="已采数量"
          min-width="180"
          align="center"
        ></el-table-column>
        <el-table-column label="采购进度" min-width="180" align="center">
          <template #default="scope">
            <span class="table-handle-btn" @click="openPlan(scope.row)">
              {{ scope.row.purchaseDemandTrackStatusDesc }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="expectedArrivalDate"
          label="期望到货日期"
          min-width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="purchaseDemandCode"
          label="需求计划编号"
          min-width="220"
          align="center"
        >
          <template #default="scope">
            <span class="table-handle-btn" @click="goDetail(scope.row.purchaseDemandId)">
              {{ scope.row.purchaseDemandCode }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="purchaseDemandName"
          label="需求计划名称"
          min-width="230"
          align="center"
        >
          <template #default="scope">
            <span>{{ scope.row.purchaseDemandName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="purchaseDemandStatusDesc"
          label="审批状态"
          min-width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建日期"
          min-width="180"
          align="center"
        ></el-table-column>
      </el-table>
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :pager-count="5"
          :page-sizes="[10, 20, 30]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="listQuery.pageNum"
          :total="total"
          :page-size.sync="listQuery.pageSize"
          prev-text="上一页"
          next-text="下一页"
        ></el-pagination>
      </div>
    </div> -->
    <track-dia
      :trackVisibleDia.sync="trackVisibleDia"
      :row="paramRow"
    ></track-dia>
  </div>
</template>
<script>
import utils from '@/modules/projectA/utils/utils';
import TrackDia from './components/trackDia.vue';
import Api from '@/modules/projectA/api/purchase';

import mixins from '../components/mixins';
import {
  tableLabel,
  fieldList,
  listTypeInfo,
} from './components/componentsData.js';
export default {
  mixins: [mixins],
  data() {
    // 采购需求状态 0:新建 1:待审核 2:审核通过 3:审核驳回
    const purchaseDemandStatusObj = {
      0: '新建', // 已保存
      1: '待审核', // 有
      2: '审核通过', // 有
      3: '审核驳回', // 有
    };
    return {
      tableLabel,
      fieldList,
      listTypeInfo,
      tableLoading: false,
      trackVisibleDia: false,
      purchaseDemandStatusObj,
      listQuery: {
        pageNum: 1,
        pageSize: 10,
        purchaseDemandCode: '',
        purchaseDemandName: '',
        endTime: '',
        startTime: '',
        purchaseDemandStatus: '',
        submitTime: null,
      },
      total: 0,
      cloneListQuery: {},
      tableData: [],
      paramRow: {},
      // selectionList:[]
    };
  },
  created() {
    this.cloneListQuery = utils.cloneDeep(this.listQuery);
    this.getList(this.listQuery);
  },
  components: {
    TrackDia,
  },
  computed: {
    mall_userInfo() {
      return this.$store.state.USERINFO;
    },
  },
  watch: {
    mall_userInfo: {
      immediate: true,
      handler: function (newVal) {
        this.userInfo = newVal;
        if (newVal.companyId) {
          this.companyId = newVal.companyId;
        }
      },
    },
  },
  methods: {
    openPlan(row) {
      this.trackVisibleDia = true;
      this.paramRow = row;
    },
    getRowKey(row) {
      console.log(row.purchaseDemandId);
      return row.purchaseDemandId;
    },
    selectionChange(val) {
      this.selectionList = val;
    },

    // 获取列表数据
    async getList(params) {
      this.tableLoading = true;
      await Api.queryPurchaseDemandLogPage(params).then((res) => {
        this.tableLoading = false;
        if (res.code === '200') {
          const data = res.data;
          this.tableData = [...data?.records];
          this.total = data?.total;
        }
      });
    },

    // 更改页码
    handleCurrentChange(val) {
      this.listQuery.pageNum = val;
      this.getList(this.listQuery);
    },

    // 更改条数
    handleSizeChange(val) {
      this.listQuery.pageNum = 1;
      this.listQuery.pageSize = val;
      this.getList(this.listQuery);
    },

    async exportDemandTrackLogSummary() {
      let res = await Api.exportDemandTrackLogSummary(this.listQuery);
      if (res.type == 'application/json') {
        utils.fileExportResponseError(res);
      } else {
        utils.downFile(res, '需求计划概要');
      }
    },

    async exportDemandTrackLogDetail() {
      let res = await Api.exportDemandTrackLogDetail(this.listQuery);
      if (res.type == 'application/json') {
        utils.fileExportResponseError(res);
      } else {
        utils.downFile(res, '需求计划详情');
      }
    },
    // 重置
    handleReset() {
      this.listQuery = { ...this.cloneListQuery };
      this.getList(this.listQuery);
    },

    // 搜索
    handleQuery(val) {
      console.log(val);
      if (val.createTime?.length) {
        val.startTime = val.createTime[0];
        val.endTime = val.createTime[1];
      } else {
        val.startTime = '';
        val.endTime = '';
        val.createTime = [];
      }
      this.listQuery = { ...val, pageNum: 1 };
      this.getList(this.listQuery);
    },

    // 修改/新增
    goCreateRe(row = {}) {
      const { purchaseDemandId = '', purchaseDemandStatus = '' } = row;
      this.$router.push({
        path: `/demand/demandManage/createDemand`,
        query: purchaseDemandId
          ? { purchaseDemandId, purchaseDemandStatus }
          : {},
      });
    },

    goDetail(purchaseDemandId) {
      this.$router.push({
        path: `/demand/demandManage/demandDetail`,
        query: { purchaseDemandId },
      });
    },
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
.requirement-submit {
  background: #fff;
  padding: 20px;
  margin-left: 10px;
  flex: 1;
  flex-direction: column;
  .margin-r20 {
    margin-right: 20px;
  }
  .tab-box {
    display: flex;
    align-items: center;
    .tab-btn {
      width: 234px;
      display: inline-block;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      background: #fff;
      // border: 1px solid #DCDFE6;
      color: #606266;
      text-align: center;
      box-sizing: border-box;
      outline: 0;
      margin: 0;
      transition: 0.1s;
      font-weight: 500;
      padding: 12px 20px;
      font-size: 14px;
      // border-radius: 4px;
      border-top: 1px solid #d9d9d9;
      border-left: 1px solid #d9d9d9;
      &:last-child {
        border-right: 1px solid #d9d9d9;
      }
      &.active {
        position: relative;
        background: #f4f7ff;
        color: #0064c8;
        border-top: 2px solid #0064c8;
        border-bottom: 0;
        z-index: 10;
      }
    }
  }
  .search-box {
    padding: 10px;
    width: 100%;
    border: 1px solid #d9d9d9;
    position: relative;
    top: -1px;
    .search-form {
      display: flex;
      flex-wrap: wrap;
      .el-form-item {
        flex: 0 0 316px;
      }
      ::v-deep .el-input {
        width: 200px;
        .el-input__inner {
          border-radius: 0;
        }
      }
      ::v-deep .el-date-editor {
        border-radius: 0;
      }
    }
  }
  .export-wrapper {
    margin: 20px 0;
    float: left;
  }
  .search-btn {
    display: flex;
    flex-direction: row;
    justify-content: center;

    .btn {
      width: 80px;
      text-align: center;
      height: 30px;
      line-height: 27px;
      cursor: pointer;
    }

    .reset-btn {
      background: #e8efff;
      border: 1px solid #2587ff;
      color: #2587ff;
      margin-right: 30px;
      line-height: 27px;
      &:hover,
      :active {
        background-color: #126edf;
        color: #fff;
      }
    }
    .submit-btn {
      background: #2587ff;
      border: 1px solid #2587ff;
      color: #ffffff;
      &:hover,
      :active {
        background-color: #126edf;
      }
    }
  }
  .handle-box {
    display: flex;
    margin: 10px 0;
    .default-btn {
      color: #333;
      border: 1px solid #dcdfe6;
    }
    .btn {
      min-width: 80px;
      padding: 0 10px;
      text-align: center;
      height: 30px;
      line-height: 27px;
      cursor: pointer;
      margin-right: 20px;
    }
    .right {
      float: right;
    }
  }
  .table-box {
    .table-handle-btn {
      color: #0064c8;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    .err-btn {
      color: #f0250f;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
  .pagination-box {
    text-align: right;
    margin-top: 20px;
    ::v-deep .el-pagination {
      button {
        height: 30px;
        color: #999;
      }
      .el-select {
        .el-input__inner {
          border-radius: 0;
          height: 30px;
        }
      }
      .el-input__inner {
        border-radius: 0;
        height: 30px;
        color: #999;
      }
      .el-select-dropdown__item,
      .el-pagination__jump,
      .el-pagination__total {
        color: #999;
        line-height: 30px;
      }
      .el-pager {
        li {
          border-radius: 0;
          border: 1px solid #d9d9d9;
          line-height: 28px;
          text-align: center;
          margin-left: 10px;
          width: 40px;
          height: 30px;
          color: #999;
          &:first-child {
            margin-left: 0;
          }
          &.active {
            background: #2587ff;
            border: none;
            color: #fff;
          }
        }
      }
    }
  }

  ::v-deep .cell {
    font-size: 14px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #333333;
    text-align: center;
  }

  ::v-deep .el-table__header-wrapper {
    height: 40px;
    background: #f5f5f5;
  }
  ::v-deep .el-table__body-wrapper {
    .empty {
      text-align: center;
      margin-bottom: 80px;
      img {
        margin-top: 60px;
        width: 204px;
        height: 124px;
      }
      p {
        height: 24px;
        line-height: 24px;
        margin-top: 10px;
        color: #333;
        font-size: 16px;
        span {
          color: #2587ff;
          cursor: pointer;
        }
      }
    }
  }
  ::v-deep .el-table th {
    padding: 0;
    height: 40px;
    background: #f5f5f5;
  }
  ::v-deep .el-table td {
    padding: 0;
    height: 50px;
  }
  .prompt-modal-title {
    display: flex;
    height: 40px;
    padding-left: 20px;
    align-items: center;
    img {
      width: 18px;
      height: 18px;
      margin-right: 10px;
      vertical-align: middle;
    }
    p {
      font-size: 14px;
      font-weight: 500;
      color: $c3;
      line-height: 14px;
    }
  }
  .prompt-modal-content {
    > h4 {
      font-weight: 500;
      color: $c3;
      margin-bottom: 5px;
    }
  }
}
</style>
